import { FocusScope } from '@react-aria/focus';
import cx from 'classnames';

import { type ColorPaletteTestIds, getTestId } from '@trello/test-ids';

import { ColorTile } from './ColorTile';
import { type Color } from './formatColor';

import styles from './ColorPalette.less';

interface ColorPaletteProps<T> {
  onClick: (color: T) => void;
  colorOptions: T[];
  selectedColor: T | null;
  isSourceSidebarMenu?: boolean;
}

export const ColorPalette = <T extends Color>({
  onClick,
  colorOptions,
  selectedColor,
  isSourceSidebarMenu,
}: ColorPaletteProps<T>) => {
  return (
    <div
      className={cx(styles.palette, {
        [styles.noHorizontalMargin]: isSourceSidebarMenu,
      })}
      data-testid={getTestId<ColorPaletteTestIds>('color-palette')}
    >
      <FocusScope>
        {colorOptions.map((color) => (
          <ColorTile
            key={color}
            color={color}
            onClick={onClick}
            isSelected={selectedColor === color}
          />
        ))}
      </FocusScope>
    </div>
  );
};
